import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { Bind } from 'primeng/bind';
import { Select } from 'primeng/select';
import { SelectChangeEvent } from 'primeng/types/select';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

export interface DropdownFilterOption {
  id: string;
  label: string;
  show?: boolean;
}

@Component({
    selector: 'myabvv-dropdown-filter',
    standalone: true,
    templateUrl: './dropdown-filter.component.html',
    imports: [Bind, Select, FormsModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownFilterComponent implements OnInit, OnChanges {
  private static nextId = 0;

  @Input() values: DropdownFilterOption[];
  @Input() label: string;
  @Output() changeValueEvent = new EventEmitter<string>();

  selectedValue: DropdownFilterOption;
  inputId = `dropdown-filter-${DropdownFilterComponent.nextId++}`;

  constructor() { }

  ngOnInit() {
    this.selectedValue = this.values.find(i => i.show === true);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['values'] && !changes['values'].firstChange) {
      this.selectedValue = this.values.find(i => i.show === true);
    }
  }

  onChangeValue(event: SelectChangeEvent) {
    this.changeValueEvent.emit(event.value.id);
  }
}
